<script>
    // Import axios for API consuming in a clean interface.
    import axios from 'axios';

    // Import multiselect component
    import Multiselect from 'vue-multiselect';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Multiselect
        },
        props: {
            filterItems: Array,
            api: String,
        },
        data() {
            return {
                loading: false,
                activeFilter: [],
                isOpened: false,
                name: 'reference',
                facetAlias: 'referentie_nr',
                options: [],
            };
        },
        computed: {
            showAllLabel() {
                return this.activeFilter.length || this.isOpened;
            },
        },
        methods: {
            onChange() {
                this.$emit('filter', {
                    type: this.name,
                    value: this.activeFilter
                });
            },
            close() {
                this.$refs.multiselect.deactivate();
            }
        },
        async created() {
            this.loading = true;

            try {
                const api = this.api + this.$store.getters.getText('dashboardApiEndpointReferences');
                const limit = 25000;
                const filterItems = this.filterItems.filter(f => f.Key !== this.facetAlias);

                const initialResponse = await axios.post(
                    api,
                    {
                        Limit: limit,
                        Offset: 0,
                        Text: '',
                        FilterItems: filterItems,
                    }
                );
                if (!initialResponse || initialResponse.status !== 200 || !initialResponse.data) throw new Error('No response or bad status');
                const totalCount = initialResponse.data.queryCount;
                let allItems = initialResponse.data.items;
                const numChunks = Math.ceil((totalCount - limit) / limit);
                if (numChunks > 0) {
                    const chunkPromises = [];
                    for (let i = 1; i <= numChunks; i++) {
                        chunkPromises.push(
                            axios.post(
                                api,
                                {
                                    Limit: limit,
                                    Offset: i * limit,
                                    Text: '',
                                    FilterItems: filterItems,
                                }
                            )
                        );
                    }
                    const chunkResults = await Promise.all(chunkPromises);
                    for (const response of chunkResults) {
                        if (!response || response.status !== 200 || !response.data) throw new Error('No response or bad status');
                        allItems = allItems.concat(response.data.items);
                    }
                }
                this.options = this.removeDuplicates(allItems.map(i => i[this.facetAlias]));
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }

            const facet = this.filterItems.find(f => f.Key === this.facetAlias);
            if (facet && facet.Values && facet.Values.length) this.activeFilter = facet.Values;

            this.loading = false;
        },
    };
</script>

<template>
    <div v-if="loading" class="has-text-centered">
        <div class="lds-facebook has-text-grey-lighter">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else class="dashboard-widget dashboard-widget--filter">
        <label for="reference" class="is-nowrap is-size-10 has-text-dark-blue">{{ $store.getters.getText('dashboardFilterReference') }}</label>
        <multiselect ref="multiselect"
                     id="reference"
                     v-model="activeFilter"
                     @select="onChange"
                     @remove="onChange"
                     :options="options"
                     :multiple="true"
                     :close-on-select="false"
                     :clear-on-select="false"
                     :preserve-search="true"
                     :placeholder="showAllLabel ? '' : $store.getters.getText('dashboardLabelAll')"
                     :showLabels="false"
                     @open="isOpened = true"
                     @close="isOpened = false">
            <template v-slot:noResult>
                <span>{{ $store.getters.getText('dashboardLabelNoresults') }}</span>
            </template>
        </multiselect>
    </div>
</template>
